import { render, staticRenderFns } from "./Heating.vue?vue&type=template&id=c4a8efde&"
import script from "./Heating.vue?vue&type=script&lang=js&"
export * from "./Heating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports